import {observable, action} from 'mobx';

export default class FavouriteDialogStore {
    /**显示编辑窗口 */
    @observable showEditDialog = false;

    /**显示选择目录窗口*/
    @observable showBrowserDialog = false;

    @action openEditDialog() {
        this.showEditDialog = true;
    }

    @action closeEditDialog() {
        this.showEditDialog = false;
    }

    @action openBrowserDialog() {
        this.showBrowserDialog = true;
    }

    @action closeBrowserDialog() {
        this.showBrowserDialog = false;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/stores/FavouriteDialogStore.js